import { Routes } from '@angular/router';
import { NotasListComponent } from './features/notas-list/notas-list';
import { NotasAdicionarComponent } from './features/notas-adicionar/notas-adicionar';
import { DownloadPdfComponent } from './features/download-pdf/download-pdf';
import { FornecedoresOcultosComponent } from './features/fornecedores-ocultos/fornecedores-ocultos';
import { RegrasComponent } from './features/regras/regras';
import { NotaDetalheComponent } from './features/nota-detalhe/nota-detalhe';
import { NotasEntregueComponent } from './features/notas-entregue/notas-entregue';
import { ExecutarLoteComponent } from './features/executar-lote/executar-lote';
import { LoginComponent } from './features/login/login';
import { ResetPasswordComponent } from './features/reset-password/reset-password';
import { TrocarSenhaComponent } from './features/trocar-senha/trocar-senha';
import { AcessoNegadoComponent } from './features/acesso-negado/acesso-negado';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'reset', component: ResetPasswordComponent, data: { title: 'Redefinir senha' } },

  {
    path: 'notas-list',
    component: NotasListComponent,
    canActivate: [authGuard],
    data: { title: 'Notas Pendentes', requiredPrivileges: ['VIEW'] }
  },
  {
    path: 'executar-lote',
    component: ExecutarLoteComponent,
    canActivate: [authGuard],
    data: { title: 'Executar Lote', requiredPrivileges: ['EXEC'] }
  },
  {
    path: 'notas-entregues',
    component: NotasEntregueComponent,
    canActivate: [authGuard],
    data: { title: 'Notas Entregues', requiredPrivileges: ['VIEW'] }
  },
  {
    path: 'nota-detalhe/:numero',
    component: NotaDetalheComponent,
    canActivate: [authGuard],
    data: { title: 'Detalhe da Nota' }
  },
  {
    path: 'notas-adicionar',
    component: NotasAdicionarComponent,
    canActivate: [authGuard],
    data: { title: 'Adicionar Notas', requiredPrivileges: ['ADD'] }
  },
  {
    path: 'download-pdf',
    component: DownloadPdfComponent,
    canActivate: [authGuard],
    data: { title: 'Download PDF', requiredPrivileges: ['EXEC'] }
  },
  {
    path: 'fornecedores-ocultos',
    component: FornecedoresOcultosComponent,
    canActivate: [authGuard],
    data: { title: 'Fornecedores Ocultos', requiredPrivileges: ['VIEW'] }
  },
  {
    path: 'regras',
    component: RegrasComponent,
    canActivate: [authGuard],
    data: { title: 'Regras de Classificação', requiredPrivileges: ['VIEW'] }
  },
  {
    path: 'trocar-senha',
    component: TrocarSenhaComponent,
    canActivate: [authGuard],
    data: { title: 'Trocar senha' }
  },
  {
    path: 'acesso-negado',
    component: AcessoNegadoComponent,
    data: { title: 'Acesso negado' }
  },

  { path: '', redirectTo: 'notas-list', pathMatch: 'full' },
  { path: '**', redirectTo: 'notas-list' }
];
